import { Record } from "immutable";
import type { RecordOf } from "immutable";
import {
  OPEN_CLONE_PAGE_DIALOG,
  CLOSE_CLONE_PAGE_DIALOG,
} from "../../helpers/constants";
import type { Actions, OpenClonePageDialog } from "../../actions/pageActions";
import type { Page } from "../../components/FormDialog/types/FormDialog.types";
import type { Account } from "../../pages/EditAccount";

export type DefaultState = {
  isOpen: boolean,
  accountsList: Account[],
  loading: boolean,
  selectedPage: Page,
}

const defaultValues: DefaultState = {
  isOpen: false,
  accountsList: [],
  loading: false,
  selectedPage: {
    id: "",
    name: "",
    type: "",
    url: "",
  },
};

export const makeState = Record(defaultValues);

export type State = RecordOf<DefaultState>;

export const initialState: State = makeState({});

export function initClonePageState(): State {
  return initialState;
}

// eslint-disable-next-line default-param-last
const clonePageReducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case OPEN_CLONE_PAGE_DIALOG: {
      const { pageId, pageName, pageType, pageUrl } = action as OpenClonePageDialog;
      return state.withMutations((newState) => {
        newState.set("isOpen", true);
        newState.setIn(["selectedPage"], {
          id: pageId,
          name: pageName,
          type: pageType,
          url: pageUrl,
        });
      });
    }
    case CLOSE_CLONE_PAGE_DIALOG: {
      return state.withMutations((newState) => {
        newState.set("isOpen", false);
        newState.setIn(["selectedPage"], {
          id: "",
          name: "",
          type: "",
          url: "",
        });
      });
    }
    default:
      return state;
  }
};

export default clonePageReducer;
